import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "utils/queryClient";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/login-page/LoginPage";
import ForgotPasswordPage from "./pages/login-page/forgot-password/ForgotPasswordPage";
// import SignupPage from "./pages/login-page/signup/SignupPage";
import ProtectedRoute from "components/protected-route/ProtectedRoute";
import GuestOnlyRoute from "components/guest-only-route/GuestOnlyRoute";
import "./index.css";
import IssuerPage from "pages/issuer-page/IssuerPage";
import IssuerLayout from "mianLayouts/IssuerLayout";
// import HdWalletTestPage from "pages/hd-wallet-test-page/HdWalletTestPage";
import NotFoundPage from "pages/not-found-page/NotFoundPage";
import UpdatePasswordPage from "./pages/update-password/UpdatePasswordPage";
import ChangePasswordPage from "pages/login-page/change-password/ChangePasswordPage";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <GuestOnlyRoute allowedUserTypes={["admin"]} redirectTo="/issuer">
                <LoginPage />
              </GuestOnlyRoute>
            }
          />
          {/* If these are ever re-enabled: /signup may be wrapped in
              GuestOnlyRoute, but /change-password must NOT be — the
              forced-rotation flow arrives there already signed in. */}
          {/* <Route path="/signup" element={<SignupPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} /> */}
          {/* ProtectedRoute wraps the LAYOUT, not the page. Two reasons: an
              unauthorized visitor should not see issuer chrome (nav, network
              selector, settings) at all, and the session-changed screen it can
              render is a full-page shell — nested inside the layout's max-width
              container it painted its own background as a visible rectangle. */}
          <Route
            path="/issuer"
            element={
              <ProtectedRoute allowedUserTypes={["admin"]}>
                <IssuerLayout>
                  <IssuerPage />
                </IssuerLayout>
              </ProtectedRoute>
            }
          />
          {/* <Route path="/hd-test" element={<HdWalletTestPage />} /> */}
          {/* Signed-out recovery. Guarded like the login page it sits beside: a signed-in admin
              is bounced to /issuer, since they want /update-password instead. Firebase hosts the
              page the emailed link opens, so there is no /reset-password route here. */}
          <Route
            path="/forgot-password"
            element={
              <GuestOnlyRoute allowedUserTypes={["admin"]} redirectTo="/issuer">
                <ForgotPasswordPage />
              </GuestOnlyRoute>
            }
          />

          {/* Voluntary password change, reached from the settings menu while signed in.
              Unlike usersApp and merchantsApp this app has no forced-rotation route to sit beside
              (the /change-password one above is commented out and useLoginForm never reads
              mustChangePassword), so this is the only password route here. Both endings sign out,
              so there is nothing to navigate back to. */}
          <Route
            path="/update-password"
            element={
              <ProtectedRoute allowedUserTypes={["admin"]}>
                <UpdatePasswordPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/change-password"
            element={
              <ProtectedRoute allowedUserTypes={["issuer-need-password-change"]}>
                <ChangePasswordPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
